<template>
  <button ref="copy_event_button" id="vue-popper__copy_event_button" @click="openCopyEventDropdown">
    {{ $t('vue2.copycalendar.copy') }} <span class="icon-arrow-down5 marg-5-left"></span>
  </button>
</template>

<script>
import eventbus from '../../eventbus'

export default {
  props: {
    event: {
      type: Object,
      default: () => {
        return {
          'id': 24035310,
          'calendar_id': 133752,
          'title': 'Billedkunst',
          'color': '#ff7f50',
          'event_time_start': '2020-10-20T06:00:00Z',
          'event_time_end': '2020-10-20T07:00:00Z'
        }
      }
    }
  },
  methods: {
    openCopyEventDropdown () {
      eventbus.copyEventEvent = this.event
    }
  }
}
</script>



// WEBPACK FOOTER //
// CopyEventButton.vue?0bbe9e3b